import React from 'react'
import { useTranslation } from 'react-i18next'

export default function Login() {
    const {t} = useTranslation();
    return (
        <div>
            <h1>{t('TEXT_LOGIN_PAGE_TITLE')}</h1>
        </div>
    )
}